// utm-monday.js
(function () {

  function injectUTMsIntoMondayForm() {

      // Read UTMs from localStorage
      const utms = {
          utm_source: localStorage.getItem("utm_source") || "",
          utm_medium: localStorage.getItem("utm_medium") || "",
          utm_campaign: localStorage.getItem("utm_campaign") || "",
          utm_content: localStorage.getItem("utm_content") || "",
          utm_term: localStorage.getItem("utm_term") || ""
      };

      // Find the Monday iframe
      const iframe = document.querySelector("iframe[src*='forms.monday.com/forms/embed']");
      if (!iframe) return;

      try {
          const url = new URL(iframe.src);

          // Add UTM params if not empty
          Object.keys(utms).forEach(key => {
              if (utms[key]) url.searchParams.set(key, utms[key]);
          });

          // Update src BEFORE iframe starts loading
          iframe.src = url.toString();

      } catch (err) {
          console.error("utm-monday: error updating iframe src", err);
      }
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", injectUTMsIntoMondayForm);
  } else {
      injectUTMsIntoMondayForm();
  }

})();
